/* eslint-disable boundaries/element-types */
import type { TClienteCompleto } from '@/features/proposta/hooks/use-orquestrar-criacao-edicao'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
import type {
  CompradorPessoaFisicaStepSchemaOutput,
  CompradorVinculoStepSchemaOutput,
} from '@/features/proposta/schemas/compradores/comprador-pf.schema'
import type { CompradorPessoaJuridicaSchemaOutput } from '@/features/proposta/schemas/compradores/comprador-pj.schema'
import { CadastroCompradorPF } from '@/pages/proposta/etapa-comprador/cadastro-comprador/cadastro-comprador-pessoa-fisica'
import { CadastroCompradorPJ } from '@/pages/proposta/etapa-comprador/cadastro-comprador/cadastro-comprador-pessoa-juridica'
import { CadastroMaePaiFluxoIndependente } from '@/pages/proposta/etapa-comprador/cadastro-comprador/cadastro-mae-pai-fluxo-independente'
import { CadastroProcuradorFluxoIndependente } from '@/pages/proposta/etapa-comprador/cadastro-comprador/cadastro-procurador-fluxo-independente'
import { CadastroRepresentanteLegalFluxoIndependente } from '@/pages/proposta/etapa-comprador/cadastro-comprador/cadastro-representante-legal-fluxo-independente'
import type { TNacionalidade, TProfissao } from '@/types/cliente'

type TFluxosCadastroCompradorProps = {
  flowKey: 'PessoaFisica' | 'PessoaJuridica' | 'Procurador' | 'MaePai' | 'Representante' | 'Conjuge' | null
  mode: 'create' | 'edit'
  nacionalidades: TNacionalidade[]
  profissoes: TProfissao[]
  clientes: TPropostaSchemaInput['cadastroCompradores']['clientes']
  compradores: TCompradoresCadastrados
  procuradores: TPropostaSchemaInput['cadastroCompradores']['procuradores']
  clientesJuridicos: TPropostaSchemaInput['cadastroCompradores']['clientesJuridicos']
  clienteToEdit: TClienteCompleto | null
  emailsJaVinculados: Record<string, string>
  clienteAtendimento?: { id: string; cpf?: string | null }
  onCancel: () => void
  onSubmit: (
    comprador:
      | CompradorPessoaFisicaStepSchemaOutput
      | CompradorPessoaJuridicaSchemaOutput
      | CompradorVinculoStepSchemaOutput,
    isDirty: boolean,
  ) => Promise<void>
}

export const FluxosCadastroComprador = ({
  flowKey,
  mode,
  nacionalidades,
  profissoes,
  clientes,
  compradores,
  procuradores,
  clientesJuridicos,
  clienteToEdit,
  emailsJaVinculados,
  clienteAtendimento,
  onCancel,
  onSubmit,
}: TFluxosCadastroCompradorProps) => {
  if (flowKey === 'PessoaFisica') {
    return (
      <CadastroCompradorPF
        nacionalidades={nacionalidades}
        profissoes={profissoes}
        clientes={clientes}
        compradores={compradores}
        clienteAtendimento={clienteAtendimento}
        clienteToEdit={clienteToEdit}
        mode={mode}
        onCancel={onCancel}
        onSubmit={onSubmit}
        emailsJaVinculados={emailsJaVinculados}
      />
    )
  }

  if (flowKey === 'PessoaJuridica') {
    return (
      <CadastroCompradorPJ
        compradores={compradores}
        nacionalidades={nacionalidades}
        profissoes={profissoes}
        clienteJuridicoToEdit={clienteToEdit}
        mode={mode}
        onCancel={onCancel}
        onSubmit={onSubmit}
        emailsJaVinculados={emailsJaVinculados}
      />
    )
  }

  if (flowKey === 'Procurador') {
    return (
      <CadastroProcuradorFluxoIndependente
        procuradorToEdit={clienteToEdit}
        compradores={compradores}
        clientes={clientes}
        procuradores={procuradores}
        nacionalidades={nacionalidades}
        profissoes={profissoes}
        onCancel={onCancel}
        onSubmit={onSubmit}
        emailsJaVinculados={emailsJaVinculados}
      />
    )
  }

  if (flowKey === 'MaePai') {
    return (
      <CadastroMaePaiFluxoIndependente
        emailsJaVinculados={emailsJaVinculados}
        clienteToEdit={clienteToEdit}
        nacionalidades={nacionalidades}
        profissoes={profissoes}
        compradores={compradores}
        clientes={clientes}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    )
  }

  if (flowKey === 'Representante') {
    return (
      <CadastroRepresentanteLegalFluxoIndependente
        representanteLegalToEdit={clienteToEdit}
        nacionalidades={nacionalidades}
        profissoes={profissoes}
        compradores={compradores}
        clientesJuridicos={clientesJuridicos}
        emailsJaVinculados={emailsJaVinculados}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    )
  }

  return null
}
